import { TableColumn, TableRow } from '@/components/Table/types';
import { t } from 'i18next';
import { Trans } from 'react-i18next';

type BillableColumnConfig<T extends TableRow> = {
  options?: Omit<TableColumn<T>, 'id' | 'label'>;
};

export const billableColumnConfig = <T extends TableRow>({
  options,
}: BillableColumnConfig<T> = {}): TableColumn<T> => ({
  id: 'billable',
  label: <Trans i18nKey="billable" />,
  render: (value) => (
    <div className="overflow-hidden text-ellipsis">
      {value ? t('yes') : t('no')}
    </div>
  ),
  acessorKey: 'billable',
  sortable: false,
  className: 'max-w-[20vw] w-[20vw]',
  ...options,
});
